import moment from "moment";
import create from "zustand";
import { roundTimeRange as top21RoundTimeRange } from "../hooks/top21ApiHooks";
import { roundTimeRange as top18RoundTimeRange } from "../hooks/top18ApiHooks";
import { roundTimeRange as top16RoundTimeRange } from "../hooks/top16ApiHooks";
import { roundTimeRange as top14RoundTimeRange } from "../hooks/top14ApiHooks";
import { roundTimeRange as top12RoundTimeRange } from "../hooks/top12ApiHooks";
import { roundTimeRange as top10RoundTimeRange } from "../hooks/top10ApiHooks";

export const useAppStore = create((set) => ({
	page: "top12-votes",
	setPage: (value) => set((state) => ({ page: value })),
	sortEnabled: false,
	setSortEnabled: (value) => set((state) => ({ sortEnabled: value })),
	listOption: "m",
	setListOption: (value) => set((state) => ({ listOption: value })),
	darkModeEnabled: false,
	setDarkModeEnabled: (value) => set((state) => ({ darkModeEnabled: value })),
	// .. top-30.................
	top30VoteTrendsMeshOrSlices: "mesh",
	setTop30VoteTrendsMeshOrSlices: (value) =>
		set((state) => ({ top30VoteTrendsMeshOrSlices: value })),
	queryTop30TrendsProgress: { m: 0, f: 0 },
	setQueryTop30TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop30TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop30TrendsProgress: newValue };
		}),
	top30VoteTrendsSlicesSortEnabled: false,
	setTop30VoteTrendsSlicesSortEnabled: (value) =>
		set((state) => ({ top30VoteTrendsSlicesSortEnabled: value })),
	// .. top-21.................
	queryTop21TrendsProgress: { m: 0, f: 0 },
	setQueryTop21TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop21TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop21TrendsProgress: newValue };
		}),
	top21TrendsRangeStart: top21RoundTimeRange.trendsStart,
	setTop21TrendsRangeStart: (value) =>
		set((state) => ({ top21TrendsRangeStart: value })),
	top21TrendsRangeEnd: "-",
	setTop21TrendsRangeEnd: (value) =>
		set((state) => ({ top21TrendsRangeEnd: value })),
	top21TrendsInterval: "01-hour",
	setTop21TrendsInterval: (value) =>
		set((state) => ({ top21TrendsInterval: value })),
	top21TimeFilter: "last-12-hours",
	setTop21TimeFilter: (value) =>
		set((state) => {
			const newState = { top21TimeFilter: value };
			if (value === "custom") {
				if (state.top21TimeFilter !== value) {
					return {
						...newState,
						top21TrendsRangeStart: top21RoundTimeRange.trendsStart,
						top21TrendsRangeEnd: "-",
					};
				}
			} else {
				newState.top21TrendsRangeStart = top21RoundTimeRange.trendsStart;
				newState.top21TrendsRangeEnd = "-";
			}

			return newState;
		}),
	// .. top-18.................
	queryTop18TrendsProgress: { m: 0, f: 0 },
	setQueryTop18TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop18TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop18TrendsProgress: newValue };
		}),
	top18TrendsRangeStart: top18RoundTimeRange.trendsStart,
	setTop18TrendsRangeStart: (value) =>
		set((state) => ({ top18TrendsRangeStart: value })),
	top18TrendsRangeEnd: "-",
	setTop18TrendsRangeEnd: (value) =>
		set((state) => ({ top18TrendsRangeEnd: value })),
	top18TrendsInterval: "30-minutes",
	setTop18TrendsInterval: (value) =>
		set((state) => ({ top18TrendsInterval: value })),
	top18TimeFilter: "last-1-hours",
	setTop18TimeFilter: (value) =>
		set((state) => {
			const newState = { top18TimeFilter: value };
			if (value === "custom") {
				if (state.top18TimeFilter !== value) {
					return {
						...newState,
						top18TrendsRangeStart: top18RoundTimeRange.trendsStart,
						top18TrendsRangeEnd: "-",
					};
				}
			} else {
				newState.top18TrendsRangeStart = top18RoundTimeRange.trendsStart;
				newState.top18TrendsRangeEnd = "-";
			}
			return newState;
		}),
	// .. top-16.................
	queryTop16TrendsProgress: { m: 0, f: 0 },
	setQueryTop16TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop16TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop16TrendsProgress: newValue };
		}),
	top16TrendsRangeStart: top16RoundTimeRange.start,
	setTop16TrendsRangeStart: (value) =>
		set((state) => ({ top16TrendsRangeStart: value })),
	top16TrendsRangeEnd: "-",
	setTop16TrendsRangeEnd: (value) =>
		set((state) => ({ top16TrendsRangeEnd: value })),
	top16TrendsInterval: "30-minutes",
	setTop16TrendsInterval: (value) =>
		set((state) => ({ top16TrendsInterval: value })),
	top16TimeFilter: "last-1-hours",
	setTop16TimeFilter: (value) =>
		set((state) => {
			const newState = { top16TimeFilter: value };
			if (value === "custom") {
				if (state.top16TimeFilter !== value) {
					return {
						...newState,
						top16TrendsRangeStart: top16RoundTimeRange.start,
						top16TrendsRangeEnd: "-",
					};
				}
			} else {
				newState.top16TrendsRangeStart = top16RoundTimeRange.start;
				newState.top16TrendsRangeEnd = "-";
			}
			return newState;
		}),
	// .. top-14.................
	queryTop14TrendsProgress: { m: 0, f: 0 },
	setQueryTop14TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop14TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop14TrendsProgress: newValue };
		}),
	top14TrendsRangeStart: top14RoundTimeRange.trendsStart,
	setTop14TrendsRangeStart: (value) =>
		set((state) => ({ top14TrendsRangeStart: value })),
	top14TrendsRangeEnd: "-",
	setTop14TrendsRangeEnd: (value) =>
		set((state) => ({ top14TrendsRangeEnd: value })),
	top14TrendsInterval: "30-minutes",
	setTop14TrendsInterval: (value) =>
		set((state) => ({ top14TrendsInterval: value })),
	top14TimeFilter: "last-1-hours",
	setTop14TimeFilter: (value) =>
		set((state) => {
			const now = moment().subtract(1, "hours");
			const max = top14RoundTimeRange.end;
			const t = now.unix() > max ? max : now.unix();
			const newState = { top14TimeFilter: value };
			if (value === "custom") {
				if (state.top14TimeFilter !== value) {
					return {
						...newState,
						top14TrendsRangeStart: t - (t % 1800),
						top14TrendsRangeEnd: "-",
					};
				}
			} else {
				newState.top14TrendsRangeStart = top14RoundTimeRange.trendsStart;
				newState.top14TrendsRangeEnd = "-";
			}
			return newState;
		}),
	top14VoteDisplayMode: "3_4",
	setTop14VoteDisplayMode: (value) =>
		set((state) => ({ top14VoteDisplayMode: value })),
	// .. top-12.................
	queryTop12TrendsProgress: { m: 0, f: 0 },
	setQueryTop12TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop12TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop12TrendsProgress: newValue };
		}),
	top12TrendsRangeStart: top12RoundTimeRange.trendsStart,
	setTop12TrendsRangeStart: (value) =>
		set((state) => ({ top12TrendsRangeStart: value })),
	top12TrendsRangeEnd: "-",
	setTop12TrendsRangeEnd: (value) =>
		set((state) => ({ top12TrendsRangeEnd: value })),
	top12TrendsInterval: "30-minutes",
	setTop12TrendsInterval: (value) =>
		set((state) => ({ top12TrendsInterval: value })),
	top12TimeFilter: "last-1-hours",
	setTop12TimeFilter: (value) =>
		set((state) => {
			const now = moment().subtract(1, "hours");
			const max = top12RoundTimeRange.end;
			const t = now.unix() > max ? max : now.unix();
			const newState = { top12TimeFilter: value };
			if (value === "custom") {
				if (state.top12TimeFilter !== value) {
					return {
						...newState,
						top12TrendsRangeStart: t - (t % 1800),
						top12TrendsRangeEnd: "-",
					};
				}
			} else {
				newState.top12TrendsRangeStart = top12RoundTimeRange.trendsStart;
				newState.top12TrendsRangeEnd = "-";
			}
			return newState;
		}),
	top12VoteDisplayMode: "3_4",
	setTop12VoteDisplayMode: (value) =>
		set((state) => ({ top12VoteDisplayMode: value })),
	top12VoteTrendsMeshOrSlices: "mesh",
	setTop12VoteTrendsMeshOrSlices: (value) =>
		set((state) => ({ top12VoteTrendsMeshOrSlices: value })),
	top12VoteTrendsSlicesSortEnabled: false,
	setTop12VoteTrendsSlicesSortEnabled: (value) =>
		set((state) => ({ top12VoteTrendsSlicesSortEnabled: value })),
	// .. top-10.................
	queryTop10TrendsProgress: { m: 0, f: 0 },
	setQueryTop10TrendsProgress: (listOption, value) =>
		set((state) => {
			const newValue = { ...state.queryTop10TrendsProgress };
			if (listOption === "m") {
				newValue.m = value;
			} else {
				newValue.f = value;
			}
			return { queryTop10TrendsProgress: newValue };
		}),
	top10TrendsRangeStart: top10RoundTimeRange.trendsStart,
	setTop10TrendsRangeStart: (value) =>
		set((state) => ({ top10TrendsRangeStart: value })),
	top10TrendsRangeEnd: "-",
	setTop10TrendsRangeEnd: (value) =>
		set((state) => ({ top10TrendsRangeEnd: value })),
	top10TrendsInterval: "30-minutes",
	setTop10TrendsInterval: (value) =>
		set((state) => ({ top10TrendsInterval: value })),
	top10TimeFilter: "last-1-hours",
	setTop10TimeFilter: (value) =>
		set((state) => {
			const now = moment().subtract(1, "hours");
			const max = top10RoundTimeRange.end;
			const t = now.unix() > max ? max : now.unix();
			const newState = { top10TimeFilter: value };
			if (value === "custom") {
				if (state.top10TimeFilter !== value) {
					return {
						...newState,
						top10TrendsRangeStart: t - (t % 1800),
						top10TrendsRangeEnd: "-",
					};
				}
			} else {
				newState.top10TrendsRangeStart = top10RoundTimeRange.trendsStart;
				newState.top10TrendsRangeEnd = "-";
			}
			return newState;
		}),
	top10VoteDisplayMode: "3_4",
	setTop10VoteDisplayMode: (value) =>
		set((state) => ({ top10VoteDisplayMode: value })),
	top10VoteTrendsMeshOrSlices: "mesh",
	setTop10VoteTrendsMeshOrSlices: (value) =>
		set((state) => ({ top10VoteTrendsMeshOrSlices: value })),
	top10VoteTrendsSlicesSortEnabled: false,
	setTop10VoteTrendsSlicesSortEnabled: (value) =>
		set((state) => ({ top10VoteTrendsSlicesSortEnabled: value })),
	// .. overall rank .................
	overallRankFilter: "top-21",
	setOverallRankFilter: (value) =>
		set((state) => ({ overallRankFilter: value })),
}));
